import { Box, Container, Stack, Typography, Button } from '@mui/material'
import React, { FC } from 'react'
import Brand from '../../Assets/brand.webp'
import { useNavigate } from 'react-router-dom'

const NotFoundPage: FC = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Container maxWidth="sm">
        <Stack
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ color: 'white' }}
        >
          <Box
            component="img"
            src={Brand}
            alt="Brand"
            sx={{
              width: '60%',
              margin: 'auto',
              marginBottom: 2
            }}
          />
          <Typography
            sx={{
              color: 'black',
              fontSize: '1.3rem',
              marginTop: 8
            }}
          >
            Página não encontrada
          </Typography>
          <Button 
            variant="contained" 
            onClick={() => navigate('/')}
            sx={{ mt: 2, color: 'white' }}
          >
            Voltar
          </Button>
        </Stack>
      </Container>
    </Box>
  )
}

export { NotFoundPage }
